import { Tkv2MarketConditionsAttachmentBody, Tkv2Property } from '@aloft/toolkit-shared';

import { Tkv2MarketConditionsState } from '../modules/marketConditions/types.ts';

export const tkv2OrderContextCompsToMarketConditionsComps = (
  comps: Record<string, Tkv2Property>,
  marketConditions: Tkv2MarketConditionsAttachmentBody,
): Tkv2MarketConditionsState['comps'] => {
  const compsMarketConditions: Tkv2MarketConditionsState['comps'] = {};

  Object.entries(comps).forEach(([compID, compProperty]) => {
    const compMarketAdjustments = marketConditions.comps?.[compID];
    const { termsOfSale, dateOfSale, concessions } = compMarketAdjustments ?? {};

    // Convert number strings to price
    const salePriceAloft = compProperty.getStructuredData('salePrice');

    const gla = compProperty.getStructuredData('gla')?.toSqFt().unitAmount;
    const salePricePerGlaAloft = gla && salePriceAloft ? salePriceAloft.div(gla) : undefined;

    compsMarketConditions[compID] = {
      grid: {
        salePrice: {
          feature: salePriceAloft?.toString(true),
        },
        salePricePerGla: {
          feature: salePricePerGlaAloft?.toString(),
        },
        termsOfSale: {
          feature: compProperty.getGridField('SalesConcessions'),
          adjustment: termsOfSale?.adjustmentAmount,
        },
        concessions: {
          feature: compProperty.getGridField('FinancingConcessions'),
          adjustment: concessions?.adjustmentAmount,
        },
        dateOfSale: {
          feature: compProperty.getGridField('DateOfSale'),
          adjustment: dateOfSale?.adjustmentAmount,
        },
      },
      property: compProperty,
    };
  });

  return compsMarketConditions;
};
